import React, { useEffect, useState, useRef } from "react";
import { Picker } from '../common/inputs';
import LoadingSpinner from '../common/loaders/loadingSpinner';
import { FormGroup } from "../common/containers/formContainer";

import authService from "../../services/authService";
import coreService from "../../services/coreService";
import useApi from '../../hooks/useApi';

function IntroducerList({ onSelectItem, selectAll = true, selectedIntroducer = null, isDisabled=false, type = null, country = null, label = null, defaultValue = { label: "Introducers", value: null } , isRequired = null, introducerType = 'all'}) {

    const { category, country_id, entity_id } = authService.getCurrentUser();
    const [data, setData] = useState([]);
    const [selectedItem, setSelectedItem] = useState(defaultValue);
    const { request, loading } = useApi(coreService.getIntrodcuersList); // Custom hook for HTTP Requests

    const searchIntroducers = async () => {
        const res = await request({introducerType});
        setData(res.data);
    };

    useEffect(() => {
        searchIntroducers();
    }, []);

    const prevCountry = useRef();

    const RenderPicker = () =>
        <Picker
            items={ selectAll === false ? data.filter(obj => obj.value !== null) : data }
            selectedItem={selectedItem}
            onSelectItem={(selectedOption) => { setSelectedItem(selectedOption); onSelectItem(selectedOption); }}
            loading={loading}
            isDisabled={isDisabled}
        />

    useEffect(() => {
        
        if (category === "Business Partner") // Set default business partner if logged in user is a BP
            onSelectItem({ value: entity_id })

        else if (country !== prevCountry.current) {
            prevCountry.current = country;
            request(
                (country === null && category !== "International Office") ? country_id : country
            );
        }

        if (selectedIntroducer !== null && data.length > 0) {
            const intoducerDetails = data.find(obj => obj.value == selectedIntroducer);
            if (intoducerDetails)
                setSelectedItem({ label: intoducerDetails.label, value: intoducerDetails.value });
        } else if (selectedIntroducer === null)
            setSelectedItem(defaultValue);

    }, [country, selectedIntroducer, data]);

    return (
            <>
                {loading == true && <LoadingSpinner />}
                {(label !== null && type !== "vertical") ?
                    <FormGroup
                        type={type}
                        label={label}
                        input={<RenderPicker />}
                    /> :
                    (label !== null && type === "vertical") ?
                        <div className={ isRequired !== null && isRequired == "true" ? "form-group required" : "form-group"}>
                            <label className={ isRequired !== null && isRequired == "true" ? "control-label" : ""}>{label}</label>
                            <RenderPicker />
                        </div>
                        :
                        <RenderPicker />
                }
        </>
    )
};
export default IntroducerList;